var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card",class:_vm.cardClass},[_c('div',{staticClass:"card-body"},[(_vm.heading !== '')?_c('h2',[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }